import React from 'react';
import DashboardSearch from './DashboardSearch';
import LandingPage from '../LandingPage';

export default function Dashboard() {
  return (
    <>
      <LandingPage>
        <DashboardSearch />
      </LandingPage>
    </>
  );
}
